var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVpayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 41,
    viewBox: "0 0 111 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00602 17.7478H4.52151C5.63597 17.7478 6.52754 16.862 6.52754 15.7548C6.52754 14.6475 5.63597 13.7617 4.52151 13.7617H2.00602C0.891566 13.7617 0 14.6475 0 15.7548C0 16.862 0.891566 17.7478 2.00602 17.7478Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0332031 1.92978C0.0332031 2.87886 0.701878 3.63812 1.62529 3.82793C1.62529 3.85957 1.72081 3.85957 1.88002 3.8912H6.01943C7.61152 3.8912 9.04439 5.31482 9.74491 6.77006L9.87227 7.02315C10.0952 7.56096 10.3499 8.16204 10.6365 8.82639C10.6365 8.85802 10.6683 8.85802 10.6683 8.88966C11.7191 11.3256 13.3749 11.8002 16.0177 11.8002H20.8258H26.3344L23.0229 4.30247L22.8 3.82793C22.6726 3.54321 22.5134 3.25849 22.3542 3.0054C21.7492 2.08796 20.9532 1.3287 19.9661 0.790895C19.9342 0.790895 19.9024 0.759259 19.9024 0.759259C19.8706 0.759259 19.8387 0.727623 19.8069 0.727623C19.2656 0.442901 18.7561 0.284722 18.3103 0.189815C17.6735 0 17.2277 0 17.2277 0H16.8138H6.27417H1.9437H1.84818C0.829244 0.0632716 0.0332031 0.885802 0.0332031 1.92978Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5031 36.7922C35.5349 36.7605 35.5349 36.7289 35.5667 36.6973C35.9488 36.0329 38.4643 30.0854 38.4643 30.0854C38.4643 30.0854 38.7828 29.2629 38.2733 28.4403C38.0186 27.9974 37.3817 27.4913 36.6175 27.5229H36.4902H19.2638H18.5315H17.4488H17.0986H17.0031C16.8757 27.5229 16.812 27.5545 16.7483 27.5545C15.8568 27.7127 15.1562 28.5036 15.1562 29.4527C15.1562 30.4967 16.016 31.3825 17.0986 31.3825C17.1304 31.3825 17.1623 31.3825 17.1941 31.3825H18.1175C19.6141 31.3825 20.9833 32.8377 21.6201 34.198L22.9256 36.9187C23.9445 39.3547 26.3645 41.063 29.1984 41.063C32.0642 40.9997 34.4841 39.2598 35.5031 36.7922Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1076 1.92978C36.1076 2.21451 36.0439 2.49923 35.9165 2.72068C35.9165 2.75231 35.8847 2.78395 35.8847 2.81559C35.8847 2.84722 35.3434 4.01775 35.3434 4.04938L32 11.7685H46.4243C47.9208 8.35185 49.29 5.15664 50.4045 2.59414C50.9458 1.36034 49.9268 0 48.5895 0H41.8391H38.1136H34.2289C35.2797 0.0316358 36.1076 0.885802 36.1076 1.92978Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7614 20.7526L16.6848 22.6192C16.7485 22.7457 16.8441 22.9355 16.9396 23.1253C17.0351 23.3151 17.1306 23.505 17.258 23.6631C17.3217 23.7897 17.4172 23.9162 17.4809 24.0111C18.4361 25.2449 20.1874 25.498 21.8432 25.498H26.5558H40.2158H40.375C41.5532 22.8406 42.8268 19.8668 44.1005 16.9563C44.3234 16.4818 44.4826 16.0705 44.4826 15.7225C44.4508 14.2673 43.2726 13.7611 42.5403 13.7611H42.0308H31.2365C31.1728 13.7611 31.1091 13.7928 31.0773 13.856L29.2941 17.9371C29.2305 18.0636 29.0394 18.0636 28.9757 17.9371L28.5618 17.2094C28.4981 17.0829 28.4344 16.988 28.3707 16.8614C27.9886 16.2287 27.511 15.6909 26.9697 15.248C25.8871 14.3622 24.5179 13.7928 23.0532 13.7295C22.9577 13.7295 22.894 13.7295 22.7984 13.7295H17.1943H12.8002H10.5076C9.45679 13.7611 8.62891 14.6153 8.62891 15.6593C8.62891 16.6084 9.32942 17.3992 10.221 17.5574C10.2528 17.5891 10.3484 17.5891 10.5076 17.5891H12.3225C13.9146 17.5891 14.9654 19.0127 15.6659 20.4363L15.7614 20.7526Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.404 17.5258L96.1307 3.47949H93.6152L101.194 20.0567L99.697 23.2202C99.0283 24.6438 98.4233 25.5929 96.9904 25.5929C96.4491 25.5929 95.9397 25.498 95.5576 25.3082L95.3028 27.1747C95.8441 27.4278 96.6084 27.5543 97.3407 27.5543C99.8562 27.5543 100.907 25.9725 101.958 23.5366L111.001 3.47949H108.485L102.404 17.5258Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2531 6.86486C80.4313 5.6627 81.8641 4.99835 83.8702 4.99835C86.9588 4.99835 88.9011 6.92813 88.9011 9.96517V11.1357C87.3091 10.7561 85.5578 10.5662 83.9975 10.5662C79.8581 10.5662 77.0879 12.6226 77.0879 15.6596C77.0879 18.6017 79.3168 20.5315 82.6602 20.5315C85.3349 20.5315 87.723 19.1395 88.933 16.7036L88.9967 20.2152H91.2256V9.68045C91.2256 5.75761 88.5509 3.13184 84.4115 3.13184C81.7049 3.13184 79.7307 3.95437 78.1705 5.44125L79.2531 6.86486ZM83.297 18.8548C80.9407 18.8548 79.5079 17.5894 79.5079 15.628C79.5079 13.6033 81.4184 12.2429 84.2841 12.2429C85.7488 12.2429 87.4046 12.4328 88.9011 12.7808C88.933 16.672 85.9717 18.8548 83.297 18.8548Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5758 16.6403C60.7221 19.013 62.951 20.5632 66.3262 20.5632C71.0388 20.5632 74.414 17.0832 74.414 11.8C74.414 6.61177 71.0706 3.13184 66.3262 3.13184C62.9829 3.13184 60.7221 4.68199 59.5758 7.05468L59.5121 3.44819H57.2832V27.2067H59.5758V16.6403ZM65.7849 5.12489C69.5104 5.12489 72.0259 7.7823 72.0259 11.8317C72.0259 15.8811 69.5422 18.6017 65.7849 18.6017C62.0913 18.6017 59.5758 15.9127 59.5758 11.8633C59.5758 7.81393 62.0595 5.12489 65.7849 5.12489Z",
    fill: "url(#paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.00177457,
    y1: 15.7528,
    x2: 50.5432,
    y2: 15.7528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.0233526,
    y1: 5.88048,
    x2: 50.5647,
    y2: 5.88048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 0.00139653,
    y1: 34.2615,
    x2: 50.5428,
    y2: 34.2615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 0.000919072,
    y1: 5.88048,
    x2: 50.5423,
    y2: 5.88048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 0.00159391,
    y1: 19.6338,
    x2: 50.543,
    y2: 19.6338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 57.2736,
    y1: 15.4964,
    x2: 110.995,
    y2: 15.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#ED2B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 57.2721,
    y1: 11.846,
    x2: 110.993,
    y2: 11.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#ED2B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 57.2729,
    y1: 15.1765,
    x2: 110.994,
    y2: 15.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#ED2B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79420"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpayLogo);
export default __webpack_public_path__ + "static/media/vpayLogo.91e113220e7203eda790fba6b84b3742.svg";
export { ForwardRef as ReactComponent };